import { render, staticRenderFns } from "./addCompay.vue?vue&type=template&id=7ada23c4&scoped=true&"
import script from "./addCompay.vue?vue&type=script&lang=js&"
export * from "./addCompay.vue?vue&type=script&lang=js&"
import style0 from "./addCompay.vue?vue&type=style&index=0&id=7ada23c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada23c4",
  null
  
)

export default component.exports